const rankings = [
  {
    rank: 1,
    title: '长风渡',
    desc: '白敬亭、宋轶主演古装甜宠剧，热度持续霸榜',
    tag: '古装',
    hot: '9.8',
    change: 'up',
  },
  {
    rank: 2,
    title: '漫长的季节',
    desc: '范伟、秦昊主演，豆瓣9.4分年度悬疑神作',
    tag: '悬疑',
    hot: '9.6',
    change: 'up',
  },
  {
    rank: 3,
    title: '黑暗荣耀',
    desc: '宋慧乔复仇爽剧，第一季+第二季全集高能',
    tag: '韩剧',
    hot: '9.4',
    change: 'same',
  },
  {
    rank: 4,
    title: '玉骨遥',
    desc: '肖战、任敏主演仙侠大剧，特效与演技齐飞',
    tag: '仙侠',
    hot: '9.1',
    change: 'up',
  },
  {
    rank: 5,
    title: '狂飙',
    desc: '张译、张颂文主演，收视与口碑双丰收的现象级国产剧',
    tag: '国产',
    hot: '8.9',
    change: 'down',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          热播排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          实时热度排行榜，发现全网最受欢迎的电视剧
        </p>
        <div className="max-w-[720px] mx-auto flex flex-col gap-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 border border-background-200 rounded-xl p-4 transition-all duration-200 hover:border-primary-200 hover:shadow-sm cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl font-heading font-bold text-lg ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-bold text-foreground-900">{item.title}</h3>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-bold text-accent-500 whitespace-nowrap">{item.hot}</span>
                <span className="w-5 h-5 flex items-center justify-center">
                  {item.change === 'up' && <i className="ri-arrow-up-fill text-primary-500 text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-fill text-foreground-400 text-sm"></i>}
                  {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}